<template>
  <div class="reg-auth-forgot" :class="{ 'big': showRegistrationBonuses }">
    <RegAuthForgotBannersDesktop v-if="!showRegistrationBonuses && !showPasswordRecovery && !showAuth" />
    <div class="reg-auth-forgot__wrapper">
      <div
        class="reg-auth-forgot__main"
        :class="{
          'full-width': showPasswordRecovery,
          'big': showRegistrationBonuses
        }"
      >
        <Auth v-if="showAuth" class="reg-auth-forgot__content" />
        <Registration v-if="showRegistration" class="reg-auth-forgot__content" />
        <PasswordRecovery v-if="showPasswordRecovery" />
        <RegistrationBonuses v-if="showRegistrationBonuses" class="reg-auth-forgot__welcome-pack" />
      </div>
    </div>
  </div>
</template>

<script>
import Auth from '@/components/BigModal/RegAuthForgot/Auth'
import Registration from '@/components/BigModal/RegAuthForgot/Registration'
import PasswordRecovery from '@/components/BigModal/RegAuthForgot/PasswordRecovery'
import RegistrationBonuses from '@/components/BigModal/RegAuthForgot/RegistrationBonuses'
import { addScrollableSelector, removeScrollableSelector } from 'scroll-lock'
import RegAuthForgotBannersDesktop from '@/components/BigModal/RegAuthForgot/RegAuthForgotBanners/Desktop'
import { mapActions, mapGetters } from 'vuex'
import { storageService } from '~/services'

export default {
  name: 'RegAuthForgot',
  components: {
    Auth,
    Registration,
    PasswordRecovery,
    RegistrationBonuses,
    RegAuthForgotBannersDesktop,
  },
  computed: {
    ...mapGetters('user', ['userId']),
    ...mapGetters('registerBonus', {
      get_registerBonusesTotalCount: 'get_registerBonusesTotalCount',
    }),
    ...mapGetters('login', ['get_resultPasswordRequest', 'get_resultPasswordChange']),
    showAuth() {
      return this.$route.query?.bigModal === 'auth'
    },
    showRegistration() {
      return !this.$route.query?.bigModal || this.$route.query?.bigModal === 'registration'
    },
    showPasswordRecovery() {
      return this.$route.query?.bigModal === 'resetPassword'
    },
    showRegistrationBonuses() {
      return this.$route.query?.bigModal === 'registrationBonuses'
    },
    isLoggedIn() {
      return this.$store.getters['user/isLoggedIn']
    },
  },
  beforeDestroy() {
    removeScrollableSelector('.big-modal__container')
  },
  created() {
    if (process.client) this.isPartner()
  },
  mounted() {
    if (this.isLoggedIn) {
      if (this.$route.query.bigModal !== 'registrationBonuses') {
        this.$newModal.closeBigModal()
      }
    }
    addScrollableSelector('.big-modal__container')
  },
  methods: {
    ...mapActions('promotions', ['fetch_partnerBanners']),
    isPartner() {
      if (storageService.getItem('adw_refcode')) {
        this.isPartnerBanner(`?${storageService.getAdwCode()}`)
      }
      else if (storageService.getItem('stag')) {
        this.isPartnerBanner(`?stag=${storageService.getItem('stag')}`)
      }
      else {
        this.isPartnerBanner()
      }
    },
    isPartnerBanner(query = '') {
      this.fetch_partnerBanners({ query })
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
